


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Third Party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Models
import Bill, { TransactionType, TransactionTypeLiterals } from '@/manager/billing/models/bill.model';
import BillLine from '@/manager/billing/models/bill-line.model';
import { Client } from '@/manager/client/client.model';
import FiscalDataExtension from '@/manager/client/models/fiscal_data.model';



// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Components
import Btn, { BtnColor, BtnWidth, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import CheckIcon, { CheckIconColor } from '@/shared/components/CheckIcon.component.vue';
import GroupButton from '@/shared/components/group-button.component.vue';
import Field from '@/shared/components/field.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import { IconEnum } from '@/shared/components/icon.component.vue';
import Input, { InputSize, InputType } from '@/shared/components/input.component.vue';
import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';
import TextArea from '@/shared/components/text-area.component.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import FlatSelectorText, {
    FlatSelectorTextPredefinedStyle,
    FlatSelectorTextBorderBottom,
    FlatSelectorTextWeight,
    FlatSelectorTextSize
} from '@/shared/components/FlatSelectorText.component.vue';
import InlineSpinner, { SpinnerSize } from '@/shared/components/inline-spinner.component.vue';

// Views
import ShoppingCartBill from '@/manager/billing/views/edit-bill-modal/shopping-cart/index.vue';
import ClientPartial from '@/manager/billing/views/edit-bill-modal/client-partial/index.vue';
import ProviderPartial from '@/manager/billing/views/edit-bill-modal/provider-partial/index.vue';

// Mixins
import SearchMixin from '@/shared/mixins/search.mixin.ts';
import ErrorMixin from '@/shared/mixins/error.mixin.ts';

// Services
import UtilsService from '@/core/services/utils.service';
import { ConvocationService, TypeOfProduct } from '@/manager/convocation/convocation.service';


interface MixinInterface extends ErrorMixin, SearchMixin { }

@Component({
    components: {
        Btn,
        CheckIcon,
        ClientPartial,
        GroupButton,
        Field,
        FieldSet,
        FlatSelectorText,
        InlineSpinner,
        Input,
        SearchAutocomplete,
        ShoppingCartBill,
        TextArea,
        TopModal,
        ProviderPartial,
    },
    methods: {
        ...mapActions({
            setCurrentBill: 'setCurrentBill',
        }),
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            clientList: 'getClientList',
            getClient: 'getClient',
            getProvider: 'getProvider',
            internalBusinessList: 'getInternalBusinessList',
            providerList: 'getProviderList',
            getProduct: 'getProduct',
            bill: 'getCurrentBill',
            hasLineProduct: 'currentBillHasLineProduct',
            receivedBillHasLineProduct: 'currentBillReceivedHasLineProduct',
        }),
    },
})
export default class EditFiscalDataModal extends Mixins<MixinInterface>(ErrorMixin, SearchMixin) {
    @Prop({ default: true }) private opened!: boolean;
    @Prop({ default: false }) private editingFiscalData!: boolean;
    @Prop({ default: undefined }) private fiscalDataExtensionEdit!: any;
    @Prop() private clientId!: string;


    private assets = Assets;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private iconEnum = IconEnum;
    private inputSize = InputSize;
    private inputType = InputType;
    private checkIconColor = CheckIconColor;
    private spinnerSize = SpinnerSize;
    private utilsService = UtilsService;
    private getProfile!: any;
    private lastNoteTyped: string = '';
    private clientList!: Client[];
    private providerList!: any[];
    private getProcedencyList !: any;
    private delegationList !: any;
    private getProduct !: any;
    private bill !: any;
    private hasLineProduct !: any;
    private receivedBillHasLineProduct !: any;
    private setCurrentBill !: any;
    private getClient !: any;
    private getProvider !: any;
    private getDelegation !: any;
    private newClient: Client = new Client();
    private nifMask = '';
    private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
    private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
    private flatSelectorTextWeight = FlatSelectorTextWeight;
    private flatSelectorTextSize = FlatSelectorTextSize;
    private procedencyOptions: any = [];
    private procedencySelected: any = {};
    private procedencyOption: any = {
        value: '0',
        label: '',
    };
    private serverError = '';
    public error = {
        delegation: '',
    };
    private requestPending = false;
    private searchOptionSelected = undefined;
    public seriesList = [
        {'name': 'VO/', 'id': 14},
        {'name': 'ASECOURSE/', 'id': 13}, 
        // {'name': 'ASECONF/', 'id': 12}, 
        // {'name': 'ASEE/', 'id': 11}, 
        {'name': 'CONF/', 'id': 10}, 
        {'name': 'COURSE/', 'id': 9}, 
        // {'name': 'E/', 'id': 8}, 
        // {'name': 'D/', 'id': 7}
    ]

    // public seriesList = [{ 'name': 'CONFERENCIA', 'id': '1' }, { 'name': 'CURSOS', 'id': '2' }, { 'name': 'EMITIDAS', 'id': null }]
    // public internalBusinessList = [{ 'name': 'LEVEL UP DESARROLLO PROFESIONAL, S.L.U.', 'id': '4' }, { 'name': 'ASESORAMIENTO A EMPRESAS LEVEL UP, S.L.', 'id': '5' }, { 'name': 'GESTIÓN INTERNA', 'id': '6' }, { 'name': 'TLP ANTIGÜO', 'id': '7' }, { 'name': 'Todas las empresas', 'id': '' }]
    // public internalBusinessList !: any
    public fiscalDataExtension: any = new FiscalDataExtension();
    private clientCountryList: any = [];
    private clientProvinceList: any = [];
    private clientPostalCodeList: any = [];
    private countryOption: any = {
        value: "0",
        label: "",
    };
    private provinceOption: any = {
        value: "0",
        label: "",
    };
    private postalCodeOption: any = {
        value: "0",
        label: "",
    };
    private zipcodes:any;

    @Watch('opened')
    private watchOpened(newVal: any, oldVal: any) {
        this.fiscalDataExtension = new FiscalDataExtension()
        // this.checkFillModalWithBillData();
        if (this.editingFiscalData) {
            this.setFiscalDataExtensionEdit(this.fiscalDataExtensionEdit)
        }
    }

    private setFiscalDataExtensionEdit(newVal: any) {
        this.fiscalDataExtension = newVal;
        console.log(this.fiscalDataExtension)
    }

    @Watch('serverError')
    private watchServerError(newVal: any, oldVal: any) {
        setTimeout(() => {
            this.serverError = '';
        }, Constants.notificationMessageTimeToAppear);
    }

    @Watch('fiscalDataExtension.phone')
    private watchPhone(newVal: any, oldVal: any) {
        if (!newVal) {
            this.fiscalDataExtension.phone = '+';
        } else if (newVal.charAt(0) != '+') {
            newVal = '+' + newVal;
            this.fiscalDataExtension.phone = newVal;
        } else {
            this.fiscalDataExtension.phone = newVal;
        }
    }

    @Watch("provinceOption")
    private watchProvince(newVal: any, oldVal: any) {
        (this.fiscalDataExtension.state as any) = newVal.value;
    }

    @Watch("countryOption")
    private watchCountry(newVal: any, oldVal: any) {
        (this.fiscalDataExtension.country as any) = newVal.value;
    }

    private created() {
        this.initializeComponent();
        this.fetchProvinceList();
        this.fetchCountryList();
    }

    private mounted() {
        this.zipcodes = this.assets.zipCodesJson
    }


    get transactionTypeOptions() {
        return [
            {
                id: String(TransactionType.TransactionEmitted),
                text: TransactionTypeLiterals[TransactionType.TransactionEmitted],
            }, {
                id: String(TransactionType.TransactionReceived),
                text: TransactionTypeLiterals[TransactionType.TransactionReceived],
            },
        ];
    }

    get searchAutocompleteOption() {
        const option = {
            placeholder: 'Busca un cliente',
            options: this.clientList,
            fields: { id: 'user.id', text: 'user.fullName' },
        };

        if (this.billIsReceived) {
            option.placeholder = 'Busca un proveedor';
            option.options = this.providerList;
            option.fields = { id: 'id', text: 'name' };
        }

        return option;
    }

    get hasSelectedClient() {
        return (this.bill.client !== null);
    }

    get lastSectionTitle() {
        let title = '';
        if (!this.editingFiscalData) {
            title = 'Añadir nota';
        }
        return title;
    }

    get billIsEmitted() {
        return this.bill.transactionType === TransactionType.TransactionEmitted;
    }

    get billIsReceived() {
        return this.bill.transactionType === TransactionType.TransactionReceived;
    }

    get hasServerError() {
        return this.serverError !== '';
    }

    get modalTitle() {
        let title = 'Añadir fiscal data extension';
        if (this.editingFiscalData) {
            title = 'Editar fiscal data';
        }
        return title;
    }

    get btnText() {
        let text = 'Guardar';
        // if ( this.editingFiscalData ) {
        //     text = 'Guardar';
        // }
        return text;
    }

    get formComplete() {
        let complete = false;
        if (this.billIsEmitted) {
            complete = (
                this.bill.client &&
                this.bill.client.user &&
                this.bill.client.user.id &&
                this.bill.internalBusiness !== undefined &&
                this.bill.billLine[0].product.id !== undefined
            );
        } else {
            complete = (
                this.bill.provider &&
                this.bill.provider.id &&
                this.bill.billLine[0].productName !== undefined &&
                this.bill.billLine[0].productAmount > 0 &&
                this.bill.billLine[0].productPrice > 0 &&
                this.bill.billLine[0].productTax > 0
            );
        }
        return complete;
    }

    get provinceSelected() {
        const provinceId = this.fiscalDataExtension.state;

        let result = {};
        if (provinceId) {
            result = this.clientProvinceList.find((option: any) => {
                return option.value === provinceId;
            });
        }

        this.fetchPostalCodeList(provinceId);
        return result;
    }

    get countrySelected() {
        const countryId = this.fiscalDataExtension.country;
        let result = {};
        if (countryId) {
            result = this.clientCountryList.find((option: any) => {
                return option.value === countryId;
            });
        }

        // this.fetchPostalCodeList(countryId);
        return result;
    }


    private initializeComponent() {
        this.remainingTime = 0;
        this.fetchInternalBusinessList();
    }

    public searchCallback() {
        if (this.searchString === '') {
            this.bill.client = new Client();
        }
        if (this.billIsEmitted) {
            this.fetchClientList();
        } else {
            this.fetchProviderList();
        }
    }

    // private transactionTypeSelected(transactionType: string) {
    //     this.bill.transactionType = Number(transactionType);
    //     this.setCurrentBill(this.bill);
    // }

    private fetchClientList() {
        const payload = {
            limit: 20,
            search: this.searchString,
        };
        this.$store.dispatch('fetchClientList', payload);
    }

    private fetchProviderList() {
        const payload = {
            limit: 20,
            search: this.searchString,
        };
        this.$store.dispatch('fetchProviderList', payload);
    }

    private closeModal() {
        if (this.opened) {
            // this.setCurrentBill(new Bill());
            this.$emit('close-modal-edit-fiscal', true);
        }
    }

    private checkMandatoryFields() {
        let result = true;

        if (!this.fiscalDataExtension.nif) {
            this.serverError = 'Se debe introducir un nif';
            result = false;
        } else if (!this.fiscalDataExtension.postalCode) {
            this.serverError = 'Se debe introducir un código postal';
            result = false;
        }
        return result;
    }

    private setParticipantFormError(err: any) {
        const serverError = err.response.data;
        const response = err.response;
        this.requestPending = false;
        if (
            response.status === 500 ||
            (
                response.status === 400 &&
                serverError.nonFieldErrors !== undefined
            )
        ) {
            this.serverError = Constants.internalServerErrorMessage;
        }
    }

    // private setIdProductInBillLines(bill: Bill) {
    //     const newLines = (bill as any).billLine.map(
    //         (line: BillLine) => {
    //             const billLine = Object.assign({}, line);
    //             const productId = (billLine.product as any).id;
    //             delete billLine.product;
    //             return {
    //                 product: productId,
    //                 ...billLine,
    //             };
    //         },
    //     );
    //     bill.billLine = newLines;
    // }

    // private checkBill() {
    //     const newBill = Object.assign({}, this.bill);
    //     newBill.billLine = Object.assign([], newBill.billLine);
    //     const billLines = (newBill as any).billLine.length;

    //     if ( billLines > 0 ) {
    //         (newBill as any).billLine.pop();
    //         this.setIdProductInBillLines(newBill);
    //     }
    //     if ( this.editingFiscalData ) {
    //         newBill.internalBusiness = this.bill.internalBusiness.id;
    //     }

    //     if ( this.billIsEmitted ) {
    //         newBill.client = this.bill.client.user.id;
    //         delete newBill.provider;
    //     } else {
    //         newBill.provider = this.bill.provider.id;
    //         delete newBill.client;
    //     }

    //     return newBill;
    // }

    private checkFiscalData() {
        const newFiscalData = Object.assign({}, this.fiscalDataExtension);
        // newBill.billLine = Object.assign([], newBill.billLine);
        // const billLines = (newBill as any).billLine.length;

        // if ( billLines > 0 ) {
        //     (newBill as any).billLine.pop();
        //     this.setIdProductInBillLines(newBill);
        // }
        // if ( this.editingFiscalData ) {
        //     newBill.internalBusiness = this.bill.internalBusiness.id;
        // }

        // if ( this.billIsEmitted ) {
        //     newBill.client = this.bill.client.user.id;
        //     delete newBill.provider;
        // } else {
        //     newBill.provider = this.bill.provider.id;
        //     delete newBill.client;
        // }

        return newFiscalData;
    }

    // private newBill() {
    //     const bill = this.checkBill();
    //     const note = { note: this.lastNoteTyped };

    //     this.$store.dispatch('newBill', {
    //         ...bill,
    //         note,
    //     }).then(
    //         (res) => {
    //             this.closeModal();
    //             this.initializeBill();
    //             setTimeout(() => {
    //                 this.$emit('new-bill', { add: true, edit: false });
    //             }, 300);
    //             this.requestPending = false;
    //         },
    //     ).catch((err) => {
    //         this.setParticipantFormError(err);
    //     });
    // }

    private newFiscalDataExtension() {
        const fiscalData = this.checkFiscalData();
        // const note = { note: this.lastNoteTyped };
        this.$store.dispatch('newFiscalDataExtension', {
            ...fiscalData,
        }).then(
            (res) => {
                this.closeModal();
                setTimeout(() => {
                    this.$emit('new-fiscal', { add: true, edit: false });
                }, 300);
                this.requestPending = false;
            },
        ).catch((err) => {
            this.setParticipantFormError(err);
        });
    }

    // private updateBill() {
    //     this.$store.dispatch('updateBill', { ...bill }).then(
    //         (res) => {
    //             this.closeModal();
    //             this.initializeBill();
    //             setTimeout(() => {
    //                 this.$emit('new-bill', { add: false, edit: true });
    //             }, 300);
    //             this.requestPending = false;
    //         },
    //     ).catch((err) => {
    //         this.setParticipantFormError(err);
    //     });
    // }

    private updateFiscalDataExtension() {
        const fiscalData = this.checkFiscalData();
        this.$store.dispatch('updateFiscalDataExtension', { ...fiscalData }).then(
            (res) => {
                this.closeModal();
                setTimeout(() => {
                    this.$emit('new-fiscal', { add: false, edit: true });
                }, 300);
                this.requestPending = false;
            },
        ).catch((err) => {
            this.setParticipantFormError(err);
        });
    }

    private sendForm() {
        this.fiscalDataExtension.user = this.clientId;
        if (this.checkMandatoryFields()) {
            this.requestPending = true;
            if (this.editingFiscalData) {
                this.updateFiscalDataExtension();
            } else {
                this.newFiscalDataExtension();
            }
        }
    }

    private selectOption(option: any) {
        if (this.billIsEmitted) {
            this.bill.client = this.getClient(option.id);
        } else {
            this.bill.provider = this.getProvider(option.id);
        }
    }

    // private clearSearchInput() {
    //     if ( this.billIsEmitted ) {
    //         this.clearClient();
    //     } else {
    //         this.clearProvider();
    //     }
    // }

    // private clearClient() {
    //     this.bill.client = new Client();
    //     this.setCurrentBill(this.bill);
    // }

    // private clearProvider() {
    //     // TODO
    // }

    // private initializeBill() {
    //     // this.setCurrentBill(new Bill());
    //     // this.clearSearchInput();
    //     // this.lastNoteTyped = '';
    // }

    // private checkAddEmptyBillLine() {
    //     const lines = (this.bill as any).billLine;
    //     const linesLength = lines.length;
    //     if ( lines[linesLength - 1].id ) {
    //         const newLine = new BillLine();
    //         lines.push(newLine);
    //     }
    // }

    // private setBillLineProductObject() {
    //     (this.bill as any).billLine.forEach((line: any) => {
    //         if ( !line.product.id ) {
    //             // console.log(this.getProduct(line.product));
    //             line.product = this.getProduct(line.product);
    //         }
    //     });
    //     this.checkAddEmptyBillLine();
    // }

    // private checkFillModalWithBillData() {
    //     if ( this.opened && this.editingFiscalData ) {
    //         this.newClient = (this.bill.client as any);
    //         this.setBillLineProductObject();
    //     } else if ( this.opened && !this.editingFiscalData ) {
    //         this.newClient = new Client();
    //     }
    // }

    private updateStoredBill() {
        this.bill.internalBusiness = this.bill.internalBusiness.id;
        this.setCurrentBill(this.bill);
    }

    private updateStoredSerie() {
        this.bill.prefix = this.bill.prefix.id;
        this.setCurrentBill(this.bill);
    }

    private fetchInternalBusinessList(callback: any = () => { const doNothing = 1; }) {
        this.$store.dispatch('fetchInternalBusinessList').then((res: any) => {
            callback();
        });
    }

    private fetchPostalCodeList(province: any) {
        this.$store.dispatch("fetchClientPostalCodeList", /* province */).then((res) => {
            this.clientPostalCodeList = res.map((e: any) => {
                const option = {
                    value: e.name || '',
                    label: e.name || '',
                    province: e.province? e.province.name: '',
                    country: e.province && e.province.country ? e.province.country.name : ''
                };
                return option;
            });
        });
    }

    private fetchProvinceList() {
        this.$store.dispatch("fetchClientProvinceList").then((res) => {
            this.clientProvinceList = res.map((e: any) => {
                const option = {
                    value: e.name,
                    label: e.name,
                };
                return option;
            });
        });
    }

    private fetchCountryList() {
        this.$store.dispatch("fetchClientCountryList").then((res) => {
            this.clientCountryList = res.map((e: any) => {
                const option = {
                    value: e.name,
                    label: e.name,
                };
                return option;
            });
        });
    }

    private updateCP(province: any) {
        this.fetchPostalCodeList(province.value);
    }

    private setProvince() {
        setTimeout(() => {
            let result = this.clientPostalCodeList.find((option: any) => {
                return option.value.slice(0, 2) === this.fiscalDataExtension.postalCode.slice(0, 2);
            });

            if (this.fiscalDataExtension.postalCode.length == 5) {
                let zipCodesResults = this.zipcodes.filter((zipcode:any) => zipcode.zipcode === this.fiscalDataExtension.postalCode);
                if (zipCodesResults.length>0) {
                this.fiscalDataExtension.town = zipCodesResults[0].place
                }
            }

            if (result) {
                this.fiscalDataExtension.country = result.country;
                this.fiscalDataExtension.state = result.province;
            }
        }, 1000);
    }

    private duplicateFiscalData() {
        this.fiscalDataExtension = {
            'user': this.clientList[0].user.id,
            'email': this.clientList[0].user.email || 'SIN@DATOS.COM',
            'address': this.clientList[0].user.profile.address || 'SIN DATOS',
            'postalCode': this.clientList[0].user.profile.postalCode,
            'country': this.clientList[0].user.profile.country || 'SIN DATOS',
            'town': this.clientList[0].user.profile.town || 'SIN DATOS',
            'firstName': this.clientList[0].user.firstName || 'SIN DATOS',
            'lastName': this.clientList[0].user.lastName || 'SIN DATOS',
            'secondLastName': this.clientList[0].user.secondLastName || 'SIN DATOS',
            'nif': this.clientList[0].user.profile.nif,
            'phone': this.clientList[0].user.profile.phone || '34',
            "isDefault": true,
            "id": this.fiscalDataExtension.id
        }
    }

}
